import { Button, ErrorMessage, Spinner } from "../../../../../widgets";
import { ControlType, FetchStatus, IEntity } from "../../../../../base/types";
import { ReloadButtonProperties, useReloadButtonProperties } from "./ReloadButtonProperties";

import { DraftReloadButtonComponent } from "./DraftReloadButtonComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../../base/models";
import { Registry } from "../../../../../base/register";
import { useFormikContext } from "formik";
import { useResetData } from "../../../../page/hooks";

export const ReloadButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { reset } = useResetData()
    const { status, properties, error } = useReloadButtonProperties(props);
    const { isSubmitting } = useFormikContext<IEntity>() || {}

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <Button
        {...properties}
        className={className}
        onClick={reset}
        iconClassName="me-1"
        disabled={properties?.disabled || isSubmitting}
    >
        {children}
    </Button>
}

Registry.addControl({
    id: "568110cc-3b96-4c24-b315-3971449ef177",
    name: "Reload Button",
    type: ControlType.ResetButton,
    properties: ReloadButtonProperties,
    component: ReloadButtonComponent,
    draftComponent: DraftReloadButtonComponent
})
